// extracted by mini-css-extract-plugin
export var dropdownButton = "_25-0";
export var fullWidthDropdownButton = "_25-1";
export var icon = "_25-3";
export var iconPlaceholder = "_25-2";
export var menuItemRow = "_25-5";
export var shortcutContainer = "_25-4";